import React, { useEffect, useState } from "react";
import "./Arrastar.scss";
import Button from "@components/button/Button";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import ReactLoading from "react-loading";
import Input from "@components/input/Input";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import MessageServices from "@services/MessageServices";
import Modal from "@components/modal/Modal";
import UtilServices from "@services/UtilServices";

export default function Arrastar(props) {
  const [lstOrdem, setLstOrdem] = useState([]);
  const [showCriar, setShowCriar] = useState([]);

  //Input Categoria.
  const [showCriar_Categoria, setShowCriar_Categoria] = useState(false);
  const [addCategoria, setAddCategoria] = useState("");

  //Input
  const [addLst, setAddLst] = useState([]);

  //Modal
  const [showModal, setShowModal] = useState(false);

  //Exlusão
  const [excluirLst, setExcluirLst] = useState([]);

  useEffect(() => {
    if (props.lstArrastar.length > 0) {
      handleMapLst();
    }
  }, [props.lstArrastar]); // Adicionado para reexecutar se `lstArrastar` mudar

  useEffect(() => {
    handleComparaLst(); //verificar a lista para habilitar o botão salvar
  }, [lstOrdem]);

  function handleMapLst() {
    const sortedList = props.lstArrastar.map((categoria) => ({
      ...categoria,
      key: UtilServices.generateUUID(),
      lst: [...categoria.lst].map((item, subIndex) => ({
        ...item,
        key: UtilServices.generateUUID(), // Adiciona uma chave única para cada item dentro da categoria
      })),
    }));

    setLstOrdem(sortedList);
  }
  function handleExcluirItem(categoriakey, key) {
    //Excluir categoria
    if (key === null) {
      setLstOrdem((prevLstLabel) =>
        prevLstLabel.filter(
          (categoria) => categoria.categoria !== categoriakey,
        ),
      );
      //Excluir Label
    } else {
      setLstOrdem((prevLstLabel) =>
        prevLstLabel.map((categoria) =>
          categoria.categoria === categoriakey
            ? {
                ...categoria,
                lst: categoria.lst.filter((item) => item?.key !== key),
              }
            : categoria,
        ),
      );
    }
  }
  function handleInput(key, e) {
    setLstOrdem((prevLstLabel) =>
      prevLstLabel.map((categoria) =>
        categoria.key === key
          ? { ...categoria, categoria: e }
          : {
              ...categoria,
              lst: categoria.lst.map((item) =>
                item.key === key ? { ...item, label: e } : item,
              ),
            },
      ),
    );
  }
  function handleComparaLst() {
    const lstModificada = lstOrdem.map((categoria) => ({
      ...Object.fromEntries(
        Object.entries(categoria).filter(([k]) => k !== "key"),
      ),
      lst: categoria.lst.map((label) => {
        const { key, ...resto } = label;
        return resto;
      }),
    }));

    let isDiferent = true;

    //se for igual ele desabilita o botão.
    if (JSON.stringify(props.lstArrastar) == JSON.stringify(lstModificada)) {
      isDiferent = false;
    }

    // Habilita ou desabilita o botão salvar dependendo de isDiferent
    props.setDisabledSalvar(isDiferent ? false : true);
  }
  function handleDragEnd(result) {
    if (!result.destination) return;

    const { source, destination, type } = result;
    const updatedList = Array.from(lstOrdem);

    if (type === "categoria") {
      // Movendo categorias
      const [movedCategory] = updatedList.splice(source.index, 1);
      updatedList.splice(destination.index, 0, movedCategory);

      // Atualizar ordemCategoria
      updatedList.forEach((categoria, index) => {
        categoria.ordemCategoria = index + 1;
      });

      setLstOrdem(updatedList);
    } else if (type === "item") {
      // Movendo itens dentro das categorias
      const categoriaOrigem = updatedList.find(
        (cat) => cat.key === source.droppableId,
      );
      const categoriaDestino = updatedList.find(
        (cat) => cat.key === destination.droppableId,
      );

      if (!categoriaOrigem || !categoriaDestino) return;

      const [movedItem] = categoriaOrigem.lst.splice(source.index, 1);
      categoriaDestino.lst.splice(destination.index, 0, movedItem);

      // Atualizar ordemLabel dos itens dentro das categorias
      categoriaOrigem.lst.forEach((item, index) => {
        item.ordemLabel = index + 1;
      });
      categoriaDestino.lst.forEach((item, index) => {
        item.ordemLabel = index + 1;
      });

      setLstOrdem(updatedList);
    }

    props.setDisabledSalvar(false);
  }
  //Input Label
  function handleAddlst_Input(e, categoria) {
    setAddLst((prevData) => {
      // Verifica se a categoria já existe
      const exists = prevData.some((item) => item.categoria === categoria);

      if (exists) {
        // Se existir, atualiza o valor da categoria
        return prevData.map((item) =>
          item.categoria === categoria ? { ...item, valor: e } : item,
        );
      } else {
        // Se não existir, adiciona um novo item
        return [...prevData, { categoria, valor: e }];
      }
    });
  }
  function handleAddlstValue_Input(categoria) {
    const label = addLst.find((item) => item.categoria === categoria)?.valor;
    return label;
  }
  function handleSalvarAddlst(categoriaParametro) {
    setLstOrdem((prevLstOrdem) =>
      prevLstOrdem.map((categoria) => {
        if (categoria.categoria === categoriaParametro) {
          const novoValor = addLst.find(
            (nv) => nv.categoria === categoriaParametro,
          );

          if (novoValor) {
            // Verifica se já existe
            const jaExiste = categoria.lst.some(
              (item) => item.label === novoValor.valor,
            );
            if (jaExiste) {
              MessageServices.ShowWarning("Já existe uma label com esse nome!");
              return categoria;
            }

            // Adiciona novo item
            return {
              ...categoria,
              lst: [
                ...categoria.lst,
                {
                  idLabel: null,
                  label: novoValor.valor,
                  ordemLabel: categoria.lst.length + 1,
                  key: UtilServices.generateUUID(),
                },
              ],
            };
          } else {
            MessageServices.ShowWarning("O valor não pode ser vazio!");
          }
        }
        return categoria;
      }),
    );

    // Remove da lista temporária de criação
    setAddLst((prev) => prev.filter((e) => e.categoria !== categoriaParametro));
    setShowCriar((prev) =>
      prev.filter((criacao) => criacao.categoria !== categoriaParametro),
    );
  }
  //Input Categoria.
  function handleSalvar_Categoria() {
    setLstOrdem((prevLstOrdem) => {
      // Verifica se a categoria a ser adicionada não está vazia
      if (!addCategoria) {
        MessageServices.ShowWarning("A categoria não pode ser vazia!");
        return prevLstOrdem; // Retorna a lista sem alterações
      }

      // Verifica se já existe a categoria na lista
      const jaExiste = prevLstOrdem.some(
        (categoria) => categoria.categoria === addCategoria,
      );
      if (jaExiste) {
        MessageServices.ShowWarning(`A categoria ${addCategoria} já existe!`);
        return prevLstOrdem; // Retorna a lista sem alterações
      }

      // Adiciona a nova categoria
      return [
        ...prevLstOrdem,
        {
          idCategoria: null,
          categoria: addCategoria,
          ordemCategoria: prevLstOrdem.length + 1,
          lst: [], // Lista vazia de itens inicialmente
          key: UtilServices.generateUUID(), // Gera um key único para a categoria
        },
      ];
    });

    // Limpa o campo de adição de categoria
    setAddCategoria("");
  }

  return (
    <>
      <div className="arrastar">
        <Button
          theme="2"
          nome="Salvar"
          icon="<i class='fa-solid fa-floppy-disk'></i>"
          title="Salvar Alterações"
          onClick={() => {
            props.onSalvar(lstOrdem);
          }}
          disabled={props.disabledSalvar}
        />
        <ButtonIcon
          Refresh
          className="label-refresh"
          titleRefresh="Recarregar objetos"
          onRefresh={() => {
            handleMapLst();
            props.setDisabledSalvar(true);
          }}
        />

        {props.loading ? (
          <div
            className="label-loading"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactLoading
              type="spin"
              color="#c1abff"
              height="30px"
              width="30px"
              className="loading"
            />
          </div>
        ) : (
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="categorias" type="categoria">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {lstOrdem?.map((item, index) => (
                    <Draggable
                      key={item.key}
                      draggableId={item.key}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className="label-lst col-6 mb-3"
                        >
                          <div
                            {...provided.dragHandleProps}
                            className="label-categoria"
                          >
                            <Input
                              value={item.categoria}
                              theme="4"
                              onChange={(e) => handleInput(item?.key, e)}
                            />
                            <ButtonIcon
                              Excluir
                              titleExcluir="Excluir registro"
                              onExcluir={() => {
                                setExcluirLst({
                                  categoria: item.categoria,
                                  key: null,
                                });
                                setShowModal(true);
                              }}
                              disabledExcluir={!props.permissoesExcluir}
                            />
                          </div>
                          <Droppable droppableId={item.key} type="item">
                            {(provided) => (
                              <ul
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                {item.lst.map((subItem, subIndex) => (
                                  <Draggable
                                    key={subItem.key}
                                    draggableId={subItem.key}
                                    index={subIndex}
                                  >
                                    {(provided) => (
                                      <li
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="label-item"
                                      >
                                        <Input
                                          value={subItem.label}
                                          theme="4"
                                          onChange={(e) =>
                                            handleInput(subItem?.key, e)
                                          }
                                        />
                                        <ButtonIcon
                                          Excluir
                                          titleExcluir="Excluir registro"
                                          onExcluir={() => {
                                            setExcluirLst({
                                              categoria: item.categoria,
                                              key: subItem.key,
                                            });
                                            setShowModal(true);
                                          }}
                                          disabledExcluir={
                                            !props.permissoesExcluir
                                          }
                                        />
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                          {showCriar?.some(
                            (criacao) => criacao.categoria === item?.categoria,
                          ) && (
                            <Input
                              className="input-criar"
                              placeholder="Valor"
                              theme="4"
                              onChange={(e) => {
                                handleAddlst_Input(e, item?.categoria);
                              }}
                              value={handleAddlstValue_Input(item?.categoria)}
                            />
                          )}
                          <div className="label-button-criar">
                            {showCriar?.some(
                              (criacao) =>
                                criacao.categoria === item?.categoria,
                            ) ? (
                              <ButtonIcon
                                Salvar
                                titleSalvar="Salvar registro"
                                onSalvar={() => {
                                  handleSalvarAddlst(item?.categoria);
                                }}
                              />
                            ) : (
                              <ButtonIcon
                                Criar
                                titleCriar="Criar um novo registro"
                                onCriar={() => {
                                  setShowCriar((prev) => [
                                    ...prev,
                                    { categoria: item?.categoria },
                                  ]);
                                }}
                                disabledCriar={!props.permissoesCriar}
                              />
                            )}
                            {showCriar?.some(
                              (criacao) =>
                                criacao.categoria === item?.categoria,
                            ) && (
                              <ButtonIcon
                                Excluir
                                titleExcluir="Excluir campos de registro"
                                onExcluir={() => {
                                  //Exclui da lst
                                  setShowCriar((prev) =>
                                    prev.filter(
                                      (criacao) =>
                                        criacao.categoria !== item?.categoria,
                                    ),
                                  );
                                  //Exclui da lst
                                  setAddLst((prev) =>
                                    prev.filter(
                                      (e) => e.categoria !== item?.categoria,
                                    ),
                                  );
                                }}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {showCriar_Categoria ? (
                    <div className="label-criar-categoria col-6">
                      <Input
                        className="input-criar"
                        placeholder="Valor"
                        theme="4"
                        onChange={(e) => {
                          setAddCategoria(e);
                        }}
                        value={addCategoria}
                      />
                      <div className="label-button-criar-categoria">
                        <ButtonIcon
                          Salvar
                          titleSalvar="Salvar registro"
                          onSalvar={() => {
                            handleSalvar_Categoria();
                          }}
                        />
                        <ButtonIcon
                          Excluir
                          titleExcluir="Excluir campos de registro"
                          onExcluir={() => {
                            setAddCategoria("");
                            setShowCriar_Categoria(false);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <ButtonIcon
                      Criar
                      titleCriar="Criar uma nova categoria"
                      onCriar={() => {
                        setShowCriar_Categoria(true);
                      }}
                      disabledCriar={!props.permissoesCriar}
                    />
                  )}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </div>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        showButton
        showButton001
        showButton002
        button001_onClick={() => {
          handleExcluirItem(excluirLst.categoria, excluirLst.key);
          setShowModal(false);
        }}
        button002_onClick={() => {
          setShowModal(false);
        }}
        title="Alerta"
      >
        <div>
          Ao excluir uma categoria ou label, todos os registros vinculados a ela
          serão automaticamente desativados e ficarão invisíveis.{" "}
          <strong>Deseja continuar ?</strong>
        </div>
      </Modal>
    </>
  );
}

Arrastar.defaultProps = {
  lstArrastar: [
    {
      categoria: "Senha",
      idCategoria: 1,
      ordemCategoria: 1,
      lst: [
        { idLabel: 1, label: "Login Ecac", ordemLabel: 1 },
        { idLabel: 2, label: "Senha Ecac", ordemLabel: 2 },
        { idLabel: 3, label: "Senha Web", ordemLabel: 3 },
      ],
    },
    {
      categoria: "Códigos",
      idCategoria: 2,
      ordemCategoria: 2,
      lst: [
        { idLabel: 1, label: "teste", ordemLabel: 1 },
        { idLabel: 2, label: "Nire", ordemLabel: 2 },
        { idLabel: 3, label: "CNAE SECUNDARIO", ordemLabel: 3 },
        { idLabel: 4, label: "testeO", ordemLabel: 4 },
      ],
    },
  ],
  //Permissões
  permissoesExcluir: false,
  permissoesSalvar: false,
  permissoesCriar: false,
  permissoesEditar: false,
  //Loading
  loading: false,
  setLoading: () => null,
  //BotãoSalvar
  disabledSalvar: true,
  setDisabledSalvar: () => null,
};
